// @ts-nocheck
import { capitalize } from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import { useIntl } from 'react-intl';
import { CustomThemeProvider, Prompt, usePortal } from 'sonata-react-components';

import { StoredReports } from '../../types';

type Props = {
  id: string;
  isLoading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
  type: StoredReports;
};

function DeleteReportPrompt({ id, isLoading, onClose, onConfirm, type }: Props) {
  const { formatMessage } = useIntl();
  const targetBodyPrompt = usePortal('deleteReportPrompt');

  const promptButtons = [
    {
      isLoading,
      onClick: onConfirm,
      text: formatMessage({
        defaultMessage: 'Accept',
        id: 'common.accept'
      }),
      type: 'primary'
    }
  ];

  return ReactDOM.createPortal(
    <CustomThemeProvider themeContrast="light">
      <Prompt
        buttons={promptButtons}
        closePrompt={onClose}
        description={formatMessage({
          defaultMessage: 'This action cannot be undone and the report will be lost.',
          id: 'reporting.reportingDownload.myReportsModal.prompt.description'
        })}
        icon="fas fa-exclamation-triangle"
        id={id}
        title={formatMessage(
          {
            defaultMessage: 'Are you sure you want to deleted this {report}?',
            id: 'reporting.reportingDownload.myReportsModal.prompt.title'
          },
          {
            report: formatMessage({
              defaultMessage: `${capitalize(type)} report`,
              id: `reporting.reportingDownload.myReportsModal.prompt.${type}`
            })
          }
        )}
      />
    </CustomThemeProvider>,
    targetBodyPrompt
  );
}

export default DeleteReportPrompt;
